// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.behaviour-drawer-backdrop {
    position: fixed;
    inset: 0;
    z-index: 200;
    background: rgba(0, 0, 0, 0.55);
    animation: behaviour-drawer-fade-in 0.2s ease;
}

.behaviour-drawer {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 201;
    width: min(480px, 100vw - 16px);
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    border: none;
    border-left: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px 0 0 12px;
    background: linear-gradient(180deg, rgba(30, 26, 20, 0.99) 0%, rgba(20, 18, 14, 1) 100%);
    box-shadow: -12px 0 48px rgba(0, 0, 0, 0.5);
    animation: behaviour-drawer-slide-in 0.26s cubic-bezier(0.32, 0.72, 0, 1);
    overflow: hidden;
}

@keyframes behaviour-drawer-fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
}

@keyframes behaviour-drawer-slide-in {
    from { transform: translateX(100%); opacity: 0.8; }
    to   { transform: translateX(0);    opacity: 1;   }
}

/* Header */
.behaviour-drawer__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 24px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    flex-shrink: 0;
}

.behaviour-drawer__header-text {
    min-width: 0;
}

.behaviour-drawer__title {
    margin: 0 0 4px;
    font-size: 1.05rem;
    font-weight: 600;
    color: #e8e8e8;
    letter-spacing: 0.01em;
}

.behaviour-drawer__sub {
    margin: 0;
    font-size: 0.78rem;
    color: rgba(255, 255, 255, 0.32);
    line-height: 1.4;
}

.behaviour-drawer__close {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    background: transparent;
    color: rgba(255, 255, 255, 0.45);
    cursor: pointer;
    font-size: 1.25rem;
    line-height: 1;
    transition: background 0.15s ease, color 0.15s ease;
}

.behaviour-drawer__close:hover {
    background: rgba(255, 255, 255, 0.06);
    color: #e8e8e8;
}

/* Body */
.behaviour-drawer__body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 24px 32px;
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.behaviour-drawer__count {
    margin: 0;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.28);
}

.behaviour-drawer__widgets {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

/* Last widget spans full width when count is odd */
.behaviour-drawer__widgets > *:last-child:nth-child(odd) {
    grid-column: 1 / -1;
}

.behaviour-drawer__empty {
    margin: 0;
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.28);
}

@media (max-width: 600px) {
    .behaviour-drawer {
        width: 100vw;
        border-radius: 0;
    }

    .behaviour-drawer__widgets {
        grid-template-columns: 1fr;
    }

    .behaviour-drawer__widgets > *:last-child:nth-child(odd) {
        grid-column: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/DecisionBehaviourDrawer/Style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,+BAA+B;IAC/B,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gDAAgD;IAChD,4BAA4B;IAC5B,wFAAwF;IACxF,2CAA2C;IAC3C,yEAAyE;IACzE,gBAAgB;AACpB;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,OAAO,2BAA2B,EAAE,YAAY,EAAE;IAClD,OAAO,wBAAwB,KAAK,UAAU,IAAI;AACtD;;AAEA,WAAW;AACX;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;IACvB,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,kBAAkB;IAClB,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA,mDAAmD;AACnD;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".behaviour-drawer-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 200;\n    background: rgba(0, 0, 0, 0.55);\n    animation: behaviour-drawer-fade-in 0.2s ease;\n}\n\n.behaviour-drawer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: 201;\n    width: min(480px, 100vw - 16px);\n    height: 100vh;\n    height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    border: none;\n    border-left: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px 0 0 12px;\n    background: linear-gradient(180deg, rgba(30, 26, 20, 0.99) 0%, rgba(20, 18, 14, 1) 100%);\n    box-shadow: -12px 0 48px rgba(0, 0, 0, 0.5);\n    animation: behaviour-drawer-slide-in 0.26s cubic-bezier(0.32, 0.72, 0, 1);\n    overflow: hidden;\n}\n\n@keyframes behaviour-drawer-fade-in {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n}\n\n@keyframes behaviour-drawer-slide-in {\n    from { transform: translateX(100%); opacity: 0.8; }\n    to   { transform: translateX(0);    opacity: 1;   }\n}\n\n/* Header */\n.behaviour-drawer__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 24px 24px 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n    flex-shrink: 0;\n}\n\n.behaviour-drawer__header-text {\n    min-width: 0;\n}\n\n.behaviour-drawer__title {\n    margin: 0 0 4px;\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: #e8e8e8;\n    letter-spacing: 0.01em;\n}\n\n.behaviour-drawer__sub {\n    margin: 0;\n    font-size: 0.78rem;\n    color: rgba(255, 255, 255, 0.32);\n    line-height: 1.4;\n}\n\n.behaviour-drawer__close {\n    flex-shrink: 0;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 6px;\n    background: transparent;\n    color: rgba(255, 255, 255, 0.45);\n    cursor: pointer;\n    font-size: 1.25rem;\n    line-height: 1;\n    transition: background 0.15s ease, color 0.15s ease;\n}\n\n.behaviour-drawer__close:hover {\n    background: rgba(255, 255, 255, 0.06);\n    color: #e8e8e8;\n}\n\n/* Body */\n.behaviour-drawer__body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px 24px 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.behaviour-drawer__count {\n    margin: 0;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.28);\n}\n\n.behaviour-drawer__widgets {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n}\n\n/* Last widget spans full width when count is odd */\n.behaviour-drawer__widgets > *:last-child:nth-child(odd) {\n    grid-column: 1 / -1;\n}\n\n.behaviour-drawer__empty {\n    margin: 0;\n    font-size: 0.875rem;\n    color: rgba(255, 255, 255, 0.28);\n}\n\n@media (max-width: 600px) {\n    .behaviour-drawer {\n        width: 100vw;\n        border-radius: 0;\n    }\n\n    .behaviour-drawer__widgets {\n        grid-template-columns: 1fr;\n    }\n\n    .behaviour-drawer__widgets > *:last-child:nth-child(odd) {\n        grid-column: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
